import { addDynamicLayers, addLayers } from './Utils/layers';

class MapStrategy {
  constructor(
    map,
    mapTilesetSources,
    layers,
    initialMetric,
    initialSizeType,
    hideLayers,
    enableEntityHighlight,
    enableCountryClick = false,
    style,
  ) {
    this.map = map;
    this.mapTilesetSources = mapTilesetSources;
    this.layers = layers;
    this.initialMetric = initialMetric;
    this.initialSizeType = initialSizeType;
    this.hideLayers = hideLayers;
    this.enableEntityHighlight = enableEntityHighlight;
    this.enableCountryClick = enableCountryClick;
    this.style = style;
  }

  // eslint-disable-next-line class-methods-use-this
  initializeLayers() {
    throw new Error('initializeLayers must be implemented by subclass');
  }
}

class DynamicMapStrategy extends MapStrategy {
  initializeLayers() {
    addDynamicLayers({ map: this.map, hideLayers: this.hideLayers });
  }
}

class StandardMapStrategy extends MapStrategy {
  initializeLayers() {
    addLayers(
      this.map,
      this.mapTilesetSources,
      this.layers,
      this.initialMetric,
      this.initialSizeType,
      this.hideLayers,
      this.enableEntityHighlight,
      this.style,
    );
  }
}

export const createMapStrategy = (mapboxPoc, ...args) => {
  return mapboxPoc ? new DynamicMapStrategy(...args) : new StandardMapStrategy(...args);
};
